import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/nejcm/docz-theme-extended/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Hint } from '@nejcm/docz-theme-extended';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "installation"
    }}>{`Installation`}</h1>
    <h2 {...{
      "id": "peer-dependencies"
    }}>{`Peer dependencies`}</h2>
    <p><em parentName="p">{`docz-theme-extended`}</em>{` requires the following peer dependencies to work. Make sure to
have them installed in your project.`}</p>
    <Hint type="info" mdxType="Hint">
  You can <strong>skip this step</strong> if those packages are already
  installed in your project.
    </Hint>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`$ npm install react@latest react-dom@latest docz@latest
`}</code></pre>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <p>{`Install the latest version of `}<em parentName="p">{`docz-theme-extended`}</em>{` by running the following command in
your project's root directory:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`$ npm install --save @nejcm/docz-theme-extended
`}</code></pre>
    <p>{`Use it in your project by adding the code below to your `}<inlineCode parentName="p">{`gatsby-config.js`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// gatsby-config.js
module.exports = {
  plugins: [
    {
      resolve: '@nejcm/docz-theme-extended',
    },
  ],
};
`}</code></pre>
    <p>{`You can read more about using themes at `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/tutorial/using-a-theme/"
      }}>{`Gatsby`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      